// extracted by mini-css-extract-plugin
module.exports = {"phoneNumber":"IntlPhoneNumberField_phoneNumber__a3Z1L","dropdownHidden":"IntlPhoneNumberField_dropdownHidden__1dYzw"};